export class MediaItemDto {
  constructor(public id: string, public name: string, public artist: string, public img: string) {
  }
}
